import { makeStyles, css } from '@conexasaude/hero'

import typoMixin from '@/styles/mixins/typo-mixin'

const useStyles = makeStyles({
  modalContent: ({ typography, colors }) => css`
    @media (max-width: 639px) {
      max-height: 220px;
      overflow: auto;
    }

    p {
      ${typoMixin({ typography }, 'body1')};
      color: ${colors.neutral[900]};

      + p {
        margin-top: 16px;
      }

      a {
        color: ${colors.primary[500]};
      }
    }
  `,
  modalFooter: ({ colors }) => css`
    display: flex;
    justify-content: flex-end;
    margin-top: 36px;

    @media (max-width: 639px) {
      flex-direction: column-reverse;
    }

    .hero-link {
      margin-right: 32px;
      color: ${colors.danger[500]};

      @media (max-width: 639px) {
        margin-top: 8px;
        margin-right: 0;
      }

      &:hover {
        color: ${colors.danger[400]};
      }
    }
  `,
})

export { useStyles }
